import { GeolocationType } from 'components/ordering/delivery-match/geolocation-type.js'

export const getCarrierImage = (carrier: string) => {
  const carrierSlug = carrier
    .toLowerCase()
    .replace(/(-|_)/g, '')

  return `${process.env['MINIO_CDN_BASE_URL'] ?? 'https://s3-cdn.cloudsuite.com'}/${process.env['MINIO_CDN_BUCKET_PREFIX'] ?? ''}delivery-match/carriers/${carrierSlug}.svg`
}

export const formatLocale = (locale: string) => {
  return locale.replace('_', '-').toLowerCase()
}

export const priceFormat = (locale: string, currency: string, price: string) => {
  const priceAsNumber = parseFloat(price)
  if (isNaN(priceAsNumber)) return 'NaN'

  const formatter = new Intl.NumberFormat(formatLocale(locale), {
    currency: currency,
    style: 'currency'
  })

  return formatter.format(priceAsNumber)
}

export const formatCenter = (geolocation: GeolocationType | undefined) => {
  if (!geolocation) {
    return '52.10192656788224,5.646937151156543'
  }
  return `${geolocation.lat},${geolocation.lon}`
}

export function capitalizeString(str: string) {
  return str.slice(0, 1).toUpperCase().concat(str.slice(1))
}

export const getRelativeDateInfo = (targetDate: Date, currentDate: Date, locale: string) => {
  const relativeFormatter = new Intl.RelativeTimeFormat(formatLocale(locale), { numeric: 'auto' })

  const dayFormatter = new Intl.DateTimeFormat(formatLocale(locale), {
    weekday: 'long',
  })

  const dateFormatter = new Intl.DateTimeFormat(formatLocale(locale), {
    day: 'numeric',
    month: 'long',
  })


  const fullDateFormatter = new Intl.DateTimeFormat(formatLocale(locale), {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })

  const correctedDeliveryDate = new Date(targetDate.setHours(0))
  const correctedCurrentDate = new Date(currentDate.setHours(0))

  const diffInMs = correctedDeliveryDate.getTime() - correctedCurrentDate.getTime()
  const diffInDays = Math.round(diffInMs / (1000 * 60 * 60 * 24))
  const weekday = dayFormatter.format(correctedDeliveryDate)

  const relativeDate = relativeFormatter.format(diffInDays, 'day')
  const date = dateFormatter.format(correctedDeliveryDate)
  const fullDate = fullDateFormatter.format(correctedDeliveryDate)

  return {
    diff: diffInDays, // target date - current date
    weekday: weekday, // Monday, Tuesday, Wednesday, Thursday, Friday, Saturday, Sunday
    relativeDate: relativeDate, // in 2 days
    date: date, // 12 September 
    dateFull: fullDate 
  }
}

export const getRelativeDistanceInfo = (distance: number) => {
  if (distance < 1000) {
    return `${distance} m`
  }
  
  const distanceInKm = distance / 1000
  // If it's a whole number, don't show decimal
  if (distanceInKm % 1 === 0) {
    return `${distanceInKm} km`
  }
  return `${distanceInKm.toFixed(1)} km`
}
